import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/zeamays.png";

const Footer = () => {
  return (
    <footer className="mt-16 border-t border-lime-200 bg-[linear-gradient(180deg,#18341f_0%,#0f2417_100%)] text-lime-50">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <img src={Logo} alt="Zea Mays Logo" className="h-11 w-11 rounded-full bg-white p-1 shadow-sm" />
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-lime-200">
                Zea Mays Foods
              </p>
              <p className="text-sm text-lime-100/80">Nigerian food products. Natural. Local. Delicious.</p>
            </div>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-6 text-lime-100/80">
            Zea Mays Foods is a food processing, nutrition, and wellness company bringing quality
            Nigerian food products and locally sourced pantry staples to more homes.
          </p>
          <div className="mt-5 inline-flex rounded-full border border-lime-500/30 bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-lime-100">
            Fresh from our kitchen to yours
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white">Quick Links</h3>
          <ul className="mt-4 space-y-3 text-sm text-lime-100/85">
            <li>
              <Link to="/" className="transition hover:text-white">
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition hover:text-white">
                About
              </Link>
            </li>
            <li>
              <Link to="/products" className="transition hover:text-white">
                Products
              </Link>
            </li>
            <li>
              <Link to="/contact" className="transition hover:text-white">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/reviews" className="transition hover:text-white">
                Reviews
              </Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="transition hover:text-white">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/shipping-policy" className="transition hover:text-white">
                Shipping Policy
              </Link>
            </li>
            <li>
              <Link to="/return-policy" className="transition hover:text-white">
                Return Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-and-conditions" className="transition hover:text-white">
                Terms & Conditions
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white">Contact Us</h3>
          <ul className="mt-4 space-y-3 text-sm text-lime-100/85">
            <li>2, Ojo Akinbinu street</li>
            <li>Off Ijede Rd, Elepe</li>
            <li>
              Email:{" "}
              <a
                href="mailto:zeamaysfood@gmail.com"
                aria-label="Send email to Zea Mays Foods"
                className="font-semibold text-white transition hover:text-lime-200"
              >
                zeamaysfood@gmail.com
              </a>
            </li>
            <li>
              Reach out to us:{" "}
              <a
                href="https://wa.me/2347037038448"
                target="_blank"
                rel="noreferrer"
                aria-label="Message Zea Mays Foods on WhatsApp"
                className="font-semibold text-white transition hover:text-lime-200"
              >
                (234)7037038448
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-white">Follow Us</h3>
          <p className="mt-4 text-sm leading-6 text-lime-100/80">
            Stay close for product drops, store updates, and kitchen highlights.
          </p>
          <div className="mt-5 flex gap-3">
            <a href="https://www.facebook.com/149756305394027?ref=NONE_xav_ig_profile_page_web" target="_blank" rel="noreferrer" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-lime-500/30 bg-white/5 transition hover:bg-white/10" aria-label="Facebook">
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path d="M14 8h3V5h-3c-2.8 0-5 2.2-5 5v2H6v3h3v6h3v-6h3l1-3h-4v-2c0-.6.4-1 1-1Z" />
              </svg>
            </a>
            <a href="https://x.com/zeamaysfood?s=20" target="_blank" rel="noreferrer" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-lime-500/30 bg-white/5 transition hover:bg-white/10" aria-label="X (formerly Twitter)">
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817-5.964 6.817H1.684l7.73-8.835L1.258 2.25H8.084l4.713 6.231 5.447-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
              </svg>
            </a>
            <a href="https://www.instagram.com/zeamaysfood/" target="_blank" rel="noreferrer" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-lime-500/30 bg-white/5 transition hover:bg-white/10" aria-label="Instagram">
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9a5.5 5.5 0 0 1-5.5 5.5h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2Zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4h-9ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm5.25-3.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" />
              </svg>
            </a>
            <a href="https://www.tiktok.com/@zeamaysfood" target="_blank" rel="noreferrer" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-lime-500/30 bg-white/5 transition hover:bg-white/10" aria-label="TikTok">
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path d="M15.5 3c.3 1.9 1.4 3.2 3.5 3.4v3.1a8.6 8.6 0 0 1-3.5-1v6.1a5.4 5.4 0 1 1-4.7-5.3v3.2a2.3 2.3 0 1 0 1.6 2.2V3h3.1Z" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/105674691/admin/dashboard/" target="_blank" rel="noreferrer" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-lime-500/30 bg-white/5 transition hover:bg-white/10" aria-label="LinkedIn">
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path d="M5.2 3.5A1.7 1.7 0 1 1 5.2 6.9a1.7 1.7 0 0 1 0-3.4ZM3.7 8.3h3v12h-3v-12Zm4.9 0h2.9v1.6h.1c.4-.8 1.4-1.9 3.4-1.9 3.6 0 4.2 2.4 4.2 5.6v6.7h-3v-5.9c0-1.4 0-3.3-2-3.3s-2.3 1.6-2.3 3.2v6h-3v-12Z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-5 text-center text-xs text-lime-100/70 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <p>&copy; {new Date().getFullYear()} Zea Mays Foods. All rights reserved.</p>
          <p>Built for fresh orders, clean tracking, and a smooth customer experience.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
